import React from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';

import { Student } from '../api/models/Student';
import { images } from '../assets/images';
import { fonts, scale } from '../Styles';

export const MNOHSRecordHeader: React.FC<{ student: Student | undefined; onBackPress: () => void }> = ({
  student,
  onBackPress,
}) => {
  return (
    <>
      {/* student header */}
      <View style={styles.studentHeader}>
        <TouchableOpacity style={styles.studentHeaderIconContainer} onPress={onBackPress}>
          <Image source={images.caretLeftIcon} style={styles.studentHeaderIcon} resizeMode="contain" />
        </TouchableOpacity>
        <Text style={styles.studentText}>
          {student?.firstName} {student?.lastName} {student?.pronoun && `(${student.pronoun})`}
        </Text>
      </View>

      {/* student details */}
      <View style={styles.studentDetails}>
        {/*<Text style={styles.detailText}>Westside High School</Text>*/}
        <Text style={styles.detailText}>{student?.email}</Text>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  studentHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    position: 'relative',
  },
  studentHeaderIconContainer: {
    position: 'absolute',
    left: 0,
  },
  studentHeaderIcon: {
    width: scale(18),
    height: scale(18),
  },
  studentText: {
    ...fonts.header1,
  },
  studentDetails: {
    backgroundColor: '#fff',
    marginVertical: scale(8),
    marginHorizontal: scale(-20),
    padding: scale(16),
  },
  detailText: {
    ...fonts.paragraph,
    textAlign: 'center',
    margin: scale(4),
  },
});
